import script from "./SyncDataView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncDataView.vue?vue&type=script&setup=true&lang=ts"

import "./SyncDataView.vue?vue&type=style&index=0&id=188d436e&lang=scss&scoped=true"

import exportComponent from "/home/deployer/pwa/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188d436e"]])

export default __exports__